import { createClient } from "@sanity/client";
import { SANITY_CONFIG } from "./config";

export const sanityClient = createClient({
  projectId: SANITY_CONFIG.projectId,
  dataset: SANITY_CONFIG.dataset,
  apiVersion: SANITY_CONFIG.apiVersion,
  useCdn: SANITY_CONFIG.useCdn,
  token: SANITY_CONFIG.token,
  perspective: SANITY_CONFIG.perspective,
});
